import {
    VERIFY_OTP,
    VERIFY_OTP_SUCCESS,
    VERIFY_OTP_FAILED
} from 'constants/ActionTypes';

export const verify_otp = (payload) => {
    return {
        type: VERIFY_OTP,
        payload
    };
};

export const verify_otp_success = (payload) => {
    return {
        type: VERIFY_OTP_SUCCESS,
        payload
    }
};

export const verify_otp_failed = (error) => {
    return {
        type: VERIFY_OTP_FAILED,
        error
    }
};

